module.exports = __webpack_public_path__ + "img/pos-icon-dark.2d09692e.svg";